import customFormsV2Client from '../infrastructure/acerill/custom-forms-v2-client';

const findAllFormsCreatingDefaultIfEmpty = () => {
  return customFormsV2Client
    .findAllForms()
    .then(forms => forms && forms.length > 0 ?
      forms :
      customFormsV2Client.createDefaultForm()
        .then(createdForm => [createdForm])
    );
};

const formService = {
  findAllFormsCreatingDefaultIfEmpty,
};

export default formService;
